<template>
  <Page2Scores
    :student="student"
    :itemRefPath="'schools/YJHjHWUGDok8teDhDIKX/xtodorhoilolt/pSPBHDgvioTxO1efDFnh'"
    :ui_setting="ui_setting"
  ></Page2Scores>
</template>
    
<script>
import { mapState } from "vuex";
import moment from "moment";
import Page2HeadTable from "./Page2HeadTable.vue";
import Page2Table from "./Page2Table.vue";
import Page2ScoreTable from "./Page2ScoreTable.vue";
import Page2Scores from "./Page2Scores.vue";
const fb = require("@/firebaseConfig.js");
export default {
  data() {
    return {};
  },
  components: {
    Page2HeadTable,
    Page2Table,
    Page2ScoreTable,
    Page2Scores,
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "xxschoolPath"]),
  },
  created() {
    console.log(this.student);
  },
  props: {
    student: {
      required: true,
      type: Object,
    },
    ui_setting: {
      required: true,
      type: Object,
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    margin: 0;
  }
}
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.a4-container {
  position: relative;
  width: 29.7cm;
  height: 21cm;
  border: 1px solid black;
  margin: 0 auto;
}
.a4-container .main-text {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  margin: 0 auto;
  box-sizing: border-box;
}

.a4-container .bottom-container {
  position: relative;
  bottom: 100px;
  display: flex;
  justify-content: space-between;
  height: 100px;

  padding-left: 40px;
  padding-right: 40px;
}

.a4-container .bottom-container .signature {
  border-top: 1px solid black;
  padding-top: 4px !important;
  margin-left: 30px;
  margin-right: 30px;
  width: 33%;
}
.signature .pclass {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.a4-container .head-score-page {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid black;
}

.a4-container .score-main {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid red;
}
.a4-container .head-score-page .title-column {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .head-score-page .title-column .column-text {
  text-align: left;
  padding: 2px;
  width: 50%;
  background-color: lightgray;
}
.a4-container .score-main .score-table-column {
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .score-signature-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid blue;
}
.a4-container .score-signature-container .score-signature {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 40%;
  background-color: lightgray;
}
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid black;
  padding: 8px;
}
.title-column .upper {
  text-transform: uppercase;
  font-weight: bold;
}
</style>